

























































































































































import Vue from 'vue'

export default Vue.extend({
  name: 'DatasetResult',
  props: {
    details: {
      type: Array,
      default: () => []
    }
  },
  data: () => {
    return {
      expanded: [] as number[]
    }
  },
  mounted () {
    let i = 0
    while (i < this.details.length) {
      this.expanded.push(i)
      i++
    }
  }
})
